/* @jsx h */
import { defineComponent, h } from "vue";

export interface CustomerCreatePanelProps {
  form: {
    name: string;
    email: string;
    phone: string;
  };
  onUpdateField: (field: "name" | "email" | "phone", value: string) => void;
  error: string;
  isSubmitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const CustomerCreatePanel = defineComponent<CustomerCreatePanelProps>({
  name: "CustomerCreatePanel",
  props: [
    "form",
    "onUpdateField",
    "error",
    "isSubmitting",
    "onSubmit",
    "onCancel",
  ],
  setup(props) {
    return () => (
      <div class="space-y-4">
        <div class="grid gap-4 md:grid-cols-2">
          <label class="form-control">
            <span class="label-text font-medium">Full name *</span>
            <input
              type="text"
              class="input input-bordered"
              placeholder="Customer name"
              value={props.form.name}
              onInput={(event) =>
                props.onUpdateField(
                  "name",
                  (event.target as HTMLInputElement).value,
                )
              }
            />
          </label>
          <label class="form-control">
            <span class="label-text font-medium">Email *</span>
            <input
              type="email"
              class="input input-bordered"
              placeholder="customer@email.com"
              value={props.form.email}
              onInput={(event) =>
                props.onUpdateField(
                  "email",
                  (event.target as HTMLInputElement).value,
                )
              }
            />
          </label>
        </div>

        {props.error && (
          <div class="alert alert-error">
            <span class="material-symbols-outlined">error</span>
            {props.error}
          </div>
        )}

        <div class="flex justify-end gap-3">
          <button
            class="btn btn-ghost"
            onClick={props.onCancel}
            disabled={props.isSubmitting}
          >
            Cancel
          </button>
          <button
            class={`btn btn-primary ${props.isSubmitting ? "" : ""}`}
            onClick={props.onSubmit}
            disabled={props.isSubmitting}
          >
            {props.isSubmitting && (
              <span class="loading loading-spinner loading-sm" />
            )}
            Create customer
          </button>
        </div>
      </div>
    );
  },
});
